module.exports = __webpack_public_path__ + "img/ger.d61bfa8e.png";